import { useState, useEffect } from 'react';
import * as SolidIcons from '@heroicons/react/24/solid';

const StatCard = ({ iconName, value, title, isLoading }) => {
    const IconComponent = SolidIcons[iconName] || SolidIcons.QuestionMarkCircleIcon;
    
    if (isLoading) {
        return (
            <div className="text-center p-4 bg-gray-100 dark:bg-gray-700/50 rounded-lg animate-pulse">
                <div className="h-12 w-12 mx-auto bg-gray-300 dark:bg-gray-600 rounded-full"></div>
                <div className="h-8 w-24 mt-2 mx-auto bg-gray-300 dark:bg-gray-600 rounded"></div>
                <div className="h-6 w-32 mt-2 mx-auto bg-gray-300 dark:bg-gray-600 rounded"></div>
            </div>
        );
    }

    return (
        <div className="text-center">
            <IconComponent className="w-12 h-12 mx-auto text-orange-500" />
            <p className="mt-2 text-4xl font-extrabold text-gray-900 dark:text-white">{value.toLocaleString()}+</p>
            <p className="text-lg text-gray-500 dark:text-gray-400">{title}</p>
        </div>
    );
};

export default function StatsCounter() {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const brandColor = '#e46809';

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/stats`);
                if (!response.ok) throw new Error('Failed to load stats');
                const data = await response.json();
                setStats(data);
            } catch (error) {
                console.error(error);
                setStats([]);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    if (!loading && stats.length === 0) {
        return null; 
    }

    return (
        // ✅ UPDATED: The section now has a subtle background color and more padding
        <section className="bg-gray-50 dark:bg-gray-800/50 py-20">
            <div className="container mx-auto px-4">

                {/* ✅ ADDED: A proper header for the section */}
                <div className="text-center max-w-2xl mx-auto mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">
                        Our Impact at a Glance
                    </h2>
                    <p className="text-lg text-gray-600 dark:text-gray-400">
                        Every gift contributes to a growing movement of empowerment and accessibility.
                    </p>
                    <div className="w-24 h-1 mx-auto mt-6" style={{ backgroundColor: brandColor }} />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {loading ? (
                        <>
                            <StatCard isLoading={true} />
                            <StatCard isLoading={true} />
                            <StatCard isLoading={true} />
                        </>
                    ) : (
                        stats.map(stat => (
                            <StatCard key={stat.title} iconName={stat.icon_name} value={stat.stat_value} title={stat.title} />
                        ))
                    )}
                </div>
            </div>
        </section>
    );
}